import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "../../../services/axios-service";

import CandidateOverview from "../../../components/Client/CandidateOverview/CandidateOverview";
import * as actions from "../../../store/actions/index";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import { regretReason } from "../../../shared/constants";
import onClickOutside from "react-onclickoutside";
import JoblistDropDown from "../../../components/UI/JobListDropDown/JobListDropDown";
import "./Feedback.css";
import Button from "../../../components/UI/Button/Button";
import Textarea from "../../../components/UI/Textarea/Textarea";
import ConsoleLog from "../../../hoc/ConsoleLog/ConsoleLog";
// import ProfileModal from '../../../components/Client/ProfileModal/ProfileModal';
import Tabs from "../../../components/UI/Tabs/Tabs";
import Tab from "../../../components/UI/Tab/Tab";
import FeedbackHistory from "../../../components/Common/FeedbackHistory/FeedbackHistory";
import LoadingIcon from "../../../assets/images/image-loader2.gif";
import "./Feedback.css";

class Feedback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      candidate_status: "",
      regretLoading: false,
      progressLoading: false,
      regretReason: "",
      feedbackComments: this.props.candidate.client_feedback,
      feedbackEditStatus: false,
      showModal: false,
      buttonText: "Save",
      regretReason: "",
      feedbackHistory: [],
      interviewExists: this.props.interviewExists
        ? this.props.interviewExists
        : null
    };
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }
  componentDidMount() {
    if (this.props.candidate.candidate_id) {
      this.setState({
        candidate_status: this.props.candidate.candidate_status,
        regretReason: this.props.candidate.regret_reason
      });
    }
    document.addEventListener("mousedown", this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  setWrapperRef(node) {
    this.wrapperRef = node;
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.regretLoading &&
      this.props.candidate.candidate_status === "REGRET"
    ) {
      this.setState({ regretLoading: false });
      this.props.handleFeedBackStatus(
        true,
        "Candidate has been regretted",
        "regret"
      );
    }

    if (
      this.state.progressLoading &&
      this.props.candidate.candidate_status === "PROGRESS"
    ) {
      this.setState({ progressLoading: false });
      this.props.handleFeedBackStatus(
        true,
        "Candidate has been progressed",
        "progress"
      );
    }

    if (
      this.props.candidate.candidate_id !== prevProps.candidate.candidate_id
    ) {
      this.setState({
        feedbackComments:
          this.props.candidate.client_feedback !== null
            ? this.props.candidate.client_feedback
            : ""
      });
      this.getEvaluationHistory();
    }

    if (this.comparePoolsStatus(this.props.pool, prevProps.pool)) {
      setTimeout(() => {
        this.getEvaluationHistory();
      }, 1500);
    }
  }

  comparePoolsStatus = (currentPool, prevPool) => {
    if (
      currentPool.find(
        candidate =>
          candidate.candidate_id === this.props.candidate.candidate_id
      ) &&
      prevPool.find(
        candidate =>
          candidate.candidate_id === this.props.candidate.candidate_id
      )
    ) {
      return (
        currentPool.find(
          candidate =>
            candidate.candidate_id === this.props.candidate.candidate_id
        ).candidate_status !==
        prevPool.find(
          candidate =>
            candidate.candidate_id === this.props.candidate.candidate_id
        ).candidate_status
      );
    } else {
      return false;
    }
  };

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({
        regretOptionsshow: false
      });
    }
  }

  handleFeedbackChange = e => {
    e.preventDefault();
    this.setState({
      feedbackComments: e.target.value,
      feedbackEditStatus: true,
      buttonText: "Save"
    });
  };

  saveFeedbackComment = () => {
    this.setState({ feedbackEditStatus: false });
    const candidateFeedbackData = {
      feedback: this.stripTags(this.state.feedbackComments),
      userName:
        this.props.clientDetails.user_fname +
        " " +
        this.props.clientDetails.user_lname,
      userId: this.props.clientDetails.user_id,
      status: this.state.candidate_status
    };
    const isShowToast = true;
    const toastMessage = "Your evaluation has been successfully submitted";
    const toastVariant = "success";
    axios
      .post(
        "/galaxy/job/" +
          this.props.jobTitleId +
          "/candidate/" +
          this.props.candidate.candidate_id +
          "/feedback",
        JSON.stringify(candidateFeedbackData)
      )
      .then(response => {
        if (response.data.message === "success") {
          // this.clearComments();
          this.setState({
            feedbackComments: candidateFeedbackData.feedback,
            buttonText: "Saved"
          });
          this.props.handlesaveFeedbackComment(
            isShowToast,
            toastMessage,
            toastVariant
          );
        }
      })
      .catch(error => {
        ConsoleLog(error);
        throw error;
      });
  };
  // close = () => {
  //   this.setState({ showModal: false});
  // }

  componentWillUpdate(prevProps, prevState) {
    if (
      this.props.candidate.candidate_status !==
        prevProps.candidate.candidate_status ||
      this.state.candidate_status == "" ||
      this.props.candidate.candidate_id !== prevProps.candidate.candidate_id ||
      this.props.candidate.regret_reason !== prevProps.candidate.regret_reason
    ) {
      this.setState({
        candidate_status: prevProps.candidate.candidate_status,
        regretReason: prevProps.candidate.regret_reason
      });
    }
  }

  clearComments = () => {
    this.setState({ feedbackComments: "" });
  };

  handleStatusChange = (status, item, candidateId) => {
    const unsortedList = this.props.pool.find(
      candidate =>
        candidate.candidate_status === "PENDING" &&
        candidate.candidate_id !== candidateId
    );
    const showModal = !unsortedList ? true : false;
    const regretLoading = status === "REGRET" ? true : false;
    const progressLoading = status === "PROGRESS" ? true : false;
    this.setState({
      candidate_status: status,
      regretOptionsshow: false,
      regretReason: item,
      regretLoading,
      progressLoading
    });
  };

  stripTags = feedbackComments => {
    const StripComments = feedbackComments.replace(/<[^>]+>/g, "");
    return StripComments;
  };

  getEvaluationHistory = () => {
    axios
      .get(
        "/galaxy/job/" +
          this.props.jobTitleId +
          "/candidate/" +
          this.props.candidate.candidate_id +
          "/history"
      )
      .then(response => {
        if (response.data) {
          this.setState({ feedbackHistory: response.data });
        }
      })
      .catch(error => {
        ConsoleLog(error);
        throw error;
      });
  };

  render() {
    const candidate = this.props.candidate;
    const candidate_status = candidate.candidate_status;
    const { regretLoading, progressLoading } = this.state;
    return (
      <div className="feedback">
        {/*<ProfileModal 
          status= {""} 
          showModal={this.state.showModal}
          close={this.close}
        />*/}
        <CandidateOverview
          {...this.props}
          candidate={candidate}
          candidate_id={candidate.candidate_id}
          candidate_status={candidate_status}
          onPoolStatusChange={this.props.onPoolStatusChange}
          isCandidateScoring={true}
          candidatePhoto={this.props.candidatePhoto}
          isS3Url={this.props.isS3Url}
        />
        <div class="line"></div>
        <div className="feedback-status-buttons">
          <Button
            className={
              candidate_status == "REGRET" ? "btn-regret active" : "btn-regret"
            }
            disabled={
              candidate_status == "REGRET" ? true : regretLoading ? true : false
            }
            value={candidate.candidate_id}
            onClick={() => this.setState({ regretOptionsshow: true })}
            buttonIconColor="navy"
            buttonicon={candidate_status !== "REGRET" ? "dropdown-arrow" : ""}
            buttoniconposition="right"
          >
            {regretLoading ? (
              <img
                className="feedback--loading"
                src={LoadingIcon}
                title="Updating..."
              />
            ) : null}
            {candidate_status == "REGRET" ? "Regretted" : "Regret"}
          </Button>
          {this.state.regretOptionsshow ? (
            <div className="regret-options-tooltip" ref={this.setWrapperRef}>
              <ul className="regret-options-list">
                {Object.keys(regretReason).map(reason => (
                  <li
                    onClick={() => {
                      this.props.onPoolStatusChange(
                        candidate.candidate_id,
                        "REGRET",
                        this.props.jobTitleId,
                        false,
                        reason,
                        this.props.clientDetails.user_id,
                        "",
                        "",
                        this.props.clientDetails.user_fname +
                          " " +
                          this.props.clientDetails.user_lname,
                        candidate_status
                      );
                      this.handleStatusChange(
                        "REGRET",
                        reason,
                        candidate.candidate_id
                      );
                    }}
                  >
                    {regretReason[reason]}
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            ""
          )}
          <Button
            className={
              candidate_status == "PROGRESS"
                ? "btn-progress active"
                : "btn-progress"
            }
            disabled={
              candidate_status === "PROGRESS"
                ? true
                : progressLoading
                ? true
                : false
            }
            value={candidate.candidate_id}
            onClick={() => {
              this.props.onPoolStatusChange(
                candidate.candidate_id,
                "PROGRESS",
                this.props.jobTitleId,
                false,
                "",
                this.props.clientDetails.user_id,
                "",
                "",
                this.props.clientDetails.user_fname +
                  " " +
                  this.props.clientDetails.user_lname,
                candidate_status
              );
              this.handleStatusChange("PROGRESS", "", candidate.candidate_id);
            }}
          >
            {progressLoading ? (
              <img
                className="feedback--loading"
                src={LoadingIcon}
                title="Updating..."
              />
            ) : null}
            {candidate_status == "PROGRESS" ? "Progressed" : "Progress"}
          </Button>
        </div>
        {candidate_status == "REGRET" ? (
          <div className="regret-reason-text">
            <span>Reason for Regret: </span>
            {regretReason[this.state.regretReason]}
          </div>
        ) : (
          ""
        )}

        {candidate_status !== "PENDING" ? (
          <div>
            <div className="hrline"></div>
            <Tabs>
              <Tab
                label="Your Evaluation"
                tabKey={1}
                onClickHandler={() => null}
              >
                <div className="your-evaluation">
                  <div className="feedback-comments">
                    <Textarea
                      name="textarea-comments"
                      placeholder={
                        "Please enter your comments here.\nYour comments may be viewed by the candidate if requested under GDPR."
                      }
                      value={this.state.feedbackComments}
                      onChange={this.handleFeedbackChange}
                    ></Textarea>
                    <Button
                      disabled={
                        this.state.feedbackComments === "" ||
                        !this.state.feedbackEditStatus
                          ? "disabled"
                          : ""
                      }
                      onClick={this.saveFeedbackComment}
                    >
                      {this.state.buttonText}
                    </Button>
                  </div>
                </div>
              </Tab>
              <Tab
                label="Evaluation History"
                tabKey={2}
                onClickHandler={this.getEvaluationHistory}
              >
                <FeedbackHistory feedbackHistory={this.state.feedbackHistory} />
              </Tab>
            </Tabs>
          </div>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    clientDetails: state.clientProfile.clientDetails,
    jobTitleId: state.talentPool.jobTitleId,
    pool: state.talentPool.pool,
    interviewExists: state.talentPool.interviewExists,
    showProgressNotification: state.talentPool.showProgressNotification
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onPoolStatusChange: (
      canidateId,
      status,
      jobId,
      isReviewAll,
      regretReason,
      scoredBy,
      score,
      totalScore,
      scoredByName,
      prevStatus
    ) =>
      dispatch(
        actions.handlePoolStatusChange(
          canidateId,
          status,
          jobId,
          isReviewAll,
          regretReason,
          scoredBy,
          score,
          totalScore,
          scoredByName,
          prevStatus
        )
      ),
    onProgressing: status => dispatch(actions.setProgressNotification(status))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(Feedback, axios));



// WEBPACK FOOTER //
// ./src/container/Client/Feedback/Feedback.js